@for (breadcrumb of breadcrumbs; track breadcrumb; let last = $last) {
<ng-template [cdkPortalOutlet]="breadcrumb"></ng-template>
@if (!last) {
<span class="onsip-breadcrumb-inserted-slash"> / </span>
} }
